const stateColors = {
  pending: "amber",
  attended: "lime",
};

function invisibleButton(btn, record) {
  return record?.state !== "pending";
}

function getView() {
  return {
    model: "melhous.request",
    form_action: ["edit"],
    table_action: ["edit"],
    activeSearch: true,
    domain: [],
    softDomain: [["id", ">", 0]],
    tags: { state: stateColors },
    fields: {
      type_name: { type: "char", searchable: true, readOnly: true },
      type: { type: "many2one", model: "melhous.request_type", readOnly: true },
      scope: {
        type: "selection",
        options: [
          { id: "table", name: "table" },
          { id: "room", name: "room" },
        ],
        translate: true,
        readOnly: true,
      },
      shop: { type: "many2one", model: "sale.shop", readOnly: true },
      place: { type: "char", searchable: true, readOnly: true },
      note: { type: "char", readOnly: true },
      state: { type: "char", readOnly: true, translate: true },
      attended_date: {
        type: "datetime",
        formatString: "YYYY-MM-DD HH:mm",
        readOnly: true,
      },
      attend: {
        type: "button",
        button_method: "attend",
        invisible: invisibleButton,
        color: "amber",
      },
    },
    list: [
      { name: "type_name", width: "25%" },
      { name: "scope", width: "10%" },
      { name: "place", width: "15%" },
      { name: "note", width: "25%" },
      { name: "state", width: "10%" },
      { name: "attend", width: "15%" },
    ],
    form: [
      { name: "type_name" },
      { name: "type" },
      { name: "scope" },
      { name: "shop" },
      { name: "place" },
      { name: "state" },
      { name: "attended_date" },
      { name: "note", colSpan: "md:col-span-2" },
      { name: "attend" },
    ],
  };
}

export default { ctxView: getView };
